import React from 'react';
import { FooterContainer } from '../../style';
import support from 'assets/images/support.svg';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { IProductsState, TProduct } from 'modules/ProductManagement/reducers/type';
import {
    getSupportNumber,
    getFormattedSupportNumber,
    getRelevantCountry,
    getSalesNumber,
    getFormattedSalestNumber,
} from '../../helper';
import { ESubscriptionStatus } from 'modules/ProductManagement/type';
import { getFirstElementInProductList } from '../../reducers/accessors';

const Footer: React.FC = () => {
    const { region } = useSelector<RootState, IProductsState>(state => state.productManagement.products);
    const { status } = useSelector<RootState, TProduct>(getFirstElementInProductList);
    const isTrial = status === ESubscriptionStatus.TRIAL;
    const phoneNumber = isTrial ? getSalesNumber(region) : getSupportNumber(region);
    const formattedSupportNumber = isTrial ? getFormattedSalestNumber(region) : getFormattedSupportNumber(region);
    const country = getRelevantCountry(region);

    return (
        <FooterContainer>
            <img src={support} alt="support image" />
            <h2>Support whenever you need</h2>
            <p>
                <span>Contact our {country} support</span>
                <span>Team 7 days a week on</span>
                <span>{phoneNumber && <a href={`tel:${phoneNumber}`}>{formattedSupportNumber}</a>}</span>
            </p>
        </FooterContainer>
    );
};

export default Footer;
